export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-dispatch/index.js
// module id = ../../../../d3-dispatch/index.js
// module chunks = 4